import { createSelector } from 'reselect';

export interface RequestsState {
  loading: boolean;
  requests: any[];
  error: string;
}

export const initialState: RequestsState = {
  loading: false,
  requests: [],
  error: '',
};

const getRequests = ({ requests }: any): RequestsState => requests;

export const requestsSelectors = {
  getRequests: createSelector(
    [getRequests],
    ({ requests }) => requests,
  ),

  getLoading: createSelector(
    getRequests,
    ({ loading }) => loading,
  ),
};



// WEBPACK FOOTER //
// ./src/scenes/Requests/services/selectors.ts